import { palette } from 'src/styles/colors';
import styled from 'styled-components';
import { HEADER_HEIGHT_IN_PIXELS_MOBILE } from '../Header.styles';
import { layout } from 'src/styles/layout';
import { HeaderDesignControllerContextData } from 'src/hooks/useHeaderDesignController';

export const SIDE_BAR_OPEN_TRANSITION_TIME = 400;

export type SideBarOpenStyle = 'compressed' | 'full-width';

interface SideBarContentProps {
  openStyle: SideBarOpenStyle;
}

interface SideBarContainerProps extends SideBarContentProps {
  isOpen: boolean;
  hasTopInfoBar: boolean;
  backgroundTheme: HeaderDesignControllerContextData['backgroundTheme'];
  textColorTheme: HeaderDesignControllerContextData['textColorTheme'];
}

export const SideBarContainer = styled.div<SideBarContainerProps>`
  position: fixed;
  top: 0;
  right: 0;
  width: ${({ openStyle }) => (openStyle === 'compressed' ? 'auto' : '100%')};
  height: ${({ openStyle }) => (openStyle === 'compressed' ? '100%' : 'auto')};
  overflow-y: scroll;
  max-height: 100vh;
  z-index: 99; // Needs to be placed below the header
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '100%')});
  transition: transform ${SIDE_BAR_OPEN_TRANSITION_TIME}ms ease-in-out;
  box-sizing: border-box;
  padding-top: ${({ hasTopInfoBar }) =>
    (hasTopInfoBar ? 16 : 0) + HEADER_HEIGHT_IN_PIXELS_MOBILE}px; // Compensation for the Header height
  --sidebar-text-color-theme: ${(props) => (props.textColorTheme === 'dark' ? palette.greyText : palette.white)};
  --sidebar-background-color-theme: ${(props) => (props.backgroundTheme === 'dark' ? palette.greyText : palette.white)};
  background-color: var(--sidebar-background-color-theme);

  @media screen and (max-width: ${layout.sm}) {
    padding-top: ${({ hasTopInfoBar }) =>
      (hasTopInfoBar ? 16 : 0) + HEADER_HEIGHT_IN_PIXELS_MOBILE}px; // Compensation for the Header & TopInfoBar height
    width: 100%; // Standard for both open styles
    height: 100%;
  }
`;

export const SideBarContent = styled.div<SideBarContentProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  // Based relative on screen height and width if compressed
  padding: ${({ openStyle }) => (openStyle === 'compressed' ? '11vh 10vw 6vh' : `3.5rem 2.5rem`)};
  // Based relative on screen height and width if compressed
  min-height: ${({ openStyle }) => (openStyle === 'compressed' ? '100%' : 'auto')};
  row-gap: ${({ openStyle }) => (openStyle === 'compressed' ? '0' : '1.5rem')};
  box-sizing: border-box;

  @media all and (max-width: ${layout.sm}) {
    min-height: 100%;
  }

  @media all and (max-width: ${layout.xs}) {
    min-height: 100%;
    padding: ${({ openStyle }) => (openStyle === 'compressed' ? '11vh 10vw 6vh' : `3.5rem 1.5rem`)};
  }
`;

export const LinksList = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export const ExternalLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1.5rem;
  align-items: center;

  .link-branded {
    width: 100%;
    padding: 11px 18px;
    max-width: 380px;
    margin: 0 auto;
  }

  #sign-in-link {
    border: none;
    background-color: transparent;
  }
`;
